import { differenceInMilliseconds } from "date-fns";
import { CleaningEventStatus } from "../types/type";
import { EXTERNAL_SERVICE_CODE } from "types/externalService";
import { DeviceStatus, TuyaDeviceStatus } from "utils/robot/deviceStatus";

/** パーツの使用期間警告値(時間) */
// 最大使用可能時間の2割以下とした
const MAINBRUSH_PERIOD_THRESHOLD = 60;
const BRUSHFILTER_PERIOD_THRESHOLD = 30;

type HasWarningConsumableParts = {
  time?: number;
  name: string;
};

type HasWarningPartsParams = {
  partsInfo: HasWarningConsumableParts[];
};

/**
 * ロボットに警告が必要な状態のパーツが存在するか。
 */
export const hasWarningParts = (input: HasWarningPartsParams) => {
  // export const hasWarningParts = (robot: CleaningRobot) => {
  return input.partsInfo.some(hasWarningConsumableParts);
};

/**
 * 警告対象の消耗品パーツが存在するか。
 */
export const hasWarningConsumableParts = (part: HasWarningConsumableParts) => {
  // export const hasWarningConsumableParts = (part: CleaningRobotParts) => {

  return (
    part.time &&
    (part.name !== "main_brush_time"
      ? Math.floor(differenceInMilliseconds(540000, part.time) / 3600) <=
        BRUSHFILTER_PERIOD_THRESHOLD
      : Math.floor(differenceInMilliseconds(1080000, part.time) / 3600) <=
        MAINBRUSH_PERIOD_THRESHOLD)
  );
};

/**
 * 警告対象のステータスが存在するか。
 */
const isStatusError = (status: CleaningEventStatus): boolean => {
  return status === "ERROR";
};

type HasWarningStatusParams = {
  manualCleaningStatus?: string;
  cleaningStatus: CleaningEventStatus;
};

export const hasWarningStatus = (event: HasWarningStatusParams) => {
  return (
    event?.manualCleaningStatus !== "COMPLETED" && // 手動清掃が完了していない
    isStatusError(event?.cleaningStatus) // 清掃ステータスがエラー
  );
};

type IsNotChargingParams = {
  deviceStatuses: DeviceStatus[];
  exSrvCode: string;
};

/**
 * `充電ができていないロボットが存在するか。
 */
export const isNotCharging = (robot: IsNotChargingParams): boolean => {
  if (robot.exSrvCode === EXTERNAL_SERVICE_CODE.TUYA) {
    const state = robot.deviceStatuses.find(
      (s) => s.type === TuyaDeviceStatus.State
    )?.status;
    const isCharging = state === "charging" || state === "fullcharge";
    return !isCharging;
  }
  return false;
};
